



































































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { Org, OrgsApi } from '../../../api';
import Toast from '@/components/display/toast.vue';
import UserPicker from '@/components/user-picker.vue';
import { OrdwayService } from '@/services/ordway-service';

@Component({
	components: {
		secondaryNav,
		vSelect,
		UserPicker,
	},
	validations: {
		form: {
			name: { required },
			adminUser: { required },
		},
	},
	mixins: [validationMixin],
})
export default class OrgUpdate extends Vue {
	public form = {
		name: '',
		organisationID: 0,
		tradingName: '',
		farmSourceName: '',
		farmSourceNumber: '',
		adminUser: {},
	};
	public org: any = null;

	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: OrgsApi;
	private previousContactId: number | null = null;

	constructor() {
		super();
		this.api = new OrgsApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { orgId } = this.$route.params;
		const { parentOrg, ...org } = this.form;

		if (this.org.adminId !== this.form.adminUser.id) {
			this.previousContactId = this.org.adminId;
		}

		org.adminId = this.form.adminUser.id;

		let response;
		try {
			response = await new OrgsApi().updateOrg(parseInt(orgId, 10), { data: org });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Updating Org', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		try {
			await OrdwayService.updateOrdwayCustomer(
				org.name,
				parseInt(orgId, 10),
				org.tradingName !== '' ? org.tradingName : undefined,
			);
		} catch (e) {
			new Toast().makeToast(
				'There was an error updating the Ordway customer for this org',
				'Ordway Error',
				'danger',
				true,
			);
			return;
		}

		if (this.previousContactId !== null) {
			try {
				await OrdwayService.changeOrdwayContact(
					this.org.id,
					this.previousContactId,
					this.form.adminUser.id,
				);
			} catch (e) {
				new Toast().makeToast(
					'There was an error updating the Ordway customer for this org',
					'Ordway Error',
					'danger',
					true,
				);
				this.submitStatus = 'ERROR';
			}
		}

		this.submitStatus = 'OK';

		new Toast().makeToast('Org Updated', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'organisations.view', params: this.$route.params });
		}, 1000);
	}

	public async load() {
		const { orgId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getOrgById(parseInt(orgId, 10), ['admin', 'address'], {
				params: {
					'fields[admin]': 'id,name',
				},
			});

			const org: Org = response.data;
			this.form.adminUser = org.admin;

			this.form.name = org.name;
			this.form.tradingName = org.tradingName;
			this.form.farmSourceName = org.farmSourceName || '';
			this.form.farmSourceNumber = org.farmSourceNumber || '';
			this.org = org;
		} catch (e) {
			console.log(e);
			this.org = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
